import { Module, Mutation, VuexModule, config } from "vuex-module-decorators";
import { IWallet, IWalletActivity, IWalletsInfo } from "../types";

config.rawError = true;

@Module({ namespaced: true })
export default class WalletsModule extends VuexModule {
  walletsInfo: IWalletsInfo | null = null;
  wallet: IWallet | null = null;
  walletActivity: IWalletActivity | null = null;
  singleWalletActivity: IWalletActivity | null = null;
  showBalances = true;
  sellTimeout = 0;

  @Mutation
  setWalletsInfo(walletsInfo: IWalletsInfo) {
    this.walletsInfo = walletsInfo;
  }

  @Mutation
  setWallet(wallet: IWallet | null) {
    this.wallet = wallet;
  }

  @Mutation
  setWalletActivity(walletActivity: IWalletActivity) {
    this.walletActivity = walletActivity;
  }

  @Mutation
  setSingleWalletActivity(singleWalletActivity: IWalletActivity) {
    this.singleWalletActivity = singleWalletActivity;
  }

  @Mutation
  toggleBalances() {
    this.showBalances = !this.showBalances;
  }

  @Mutation
  setSellTimeout(seconds: number) {
    this.sellTimeout = seconds;
  }

  @Mutation
  clear() {
    this.walletsInfo = null;
    this.showBalances = true;
    this.sellTimeout = 0;
  }
}
